import { request } from "../apiService";

export const addFavoriteToUser = async (
    favoriteUserId: string
): Promise<void> => {
    return await request(`/v3/favorites/${favoriteUserId}`, {
        method: "POST",
    });
};

export const removeFavoriteFromUser = async (
    favoriteUserId: string
): Promise<void> => {
    return await request(`/v3/favorites/${favoriteUserId}`, {
        method: "DELETE",
    });
};